import React from 'react';
type ThreatLevel = 'low' | 'moderate' | 'high' | 'critical';
interface ThreatLevelIndicatorProps {
  level: ThreatLevel;
}
const ThreatLevelIndicator: React.FC<ThreatLevelIndicatorProps> = ({
  level
}) => {
  const getColorClass = () => {
    switch (level) {
      case 'low':
        return 'bg-green-500';
      case 'moderate':
        return 'bg-yellow-500';
      case 'high':
        return 'bg-orange-500';
      case 'critical':
        return 'bg-red-600';
      default:
        return 'bg-gray-500';
    }
  };
  const getLabel = () => {
    return level.charAt(0).toUpperCase() + level.slice(1);
  };
  return <div className="flex items-center" data-id="element-28">
      <div className={`w-3 h-3 rounded-full ${getColorClass()} mr-2`} data-id="element-29"></div>
      <span className="text-sm font-medium" data-id="element-30">{getLabel()}</span>
    </div>;
};
export default ThreatLevelIndicator;